<script setup>
import useSharedData from "@/use/SharedData";
import {defineEmits, defineProps} from "vue";
import WBtnValidate from "@/components/WBtnValidate.vue";

defineProps({
    loading: Boolean,
    overlay: Boolean,
    deleteAction: Boolean,
    validateAction: Boolean,
    archiveAction: Boolean,
    unarchiveAction: Boolean,
    activateAction: Boolean,
    deactivateAction: Boolean,
    lockAction: Boolean,
    unlockAction: Boolean,
});

const emit = defineEmits(["remove", "archive", "unarchive", "validate", "activate", "deactivate", "lock", "unlock", "cancel"]);

const {overlayOpacity} = useSharedData();

function remove() {
    emit('remove');
}

function archive() {
    emit('archive');
}

function unarchive() {
    emit('unarchive');
}

function validate() {
    emit('validate');
}

function activate() {
    emit('activate');
}

function deactivate() {
    emit('deactivate');
}

function lock() {
    emit('lock');
}

function unlock() {
    emit('unlock');
}

function cancel() {
    emit('cancel');
}
</script>

<template>
    <v-overlay absolute :value="overlay" :opacity="overlayOpacity">
        <v-row>
            <v-col>
                <w-btn-delete
                    :show="deleteAction"
                    :loading="loading"
                    @press="remove"
                />
                <w-btn-archive
                    :show="archiveAction"
                    :loading="loading"
                    @press="archive"
                />
                <w-btn-unarchive
                    :show="unarchiveAction"
                    :loading="loading"
                    @press="unarchive"
                />
                   <w-btn-validate
                    :show="validateAction"
                    :loading="loading"
                    @press="validate"
                />
                <w-btn-activate
                    :show="activateAction"
                    :loading="loading"
                    @press="activate"
                />
                <w-btn-deactivate
                    :show="deactivateAction"
                    :loading="loading"
                    @press="deactivate"
                />
                <w-btn-lock
                    :show="lockAction"
                    :loading="loading"
                    @press="lock"
                />
                <w-btn-unlock
                    :show="unlockAction"
                    :loading="loading"
                    @press="unlock"
                />
            </v-col>
            <v-col>
                <w-btn
                    icon="mdi-close"
                    color="teal"
                    :text="$t('common.close')"
                    :loading="loading"
                    @press="cancel"
                />
            </v-col>
        </v-row>
    </v-overlay>
</template>

<style scoped>

</style>